/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.authFullChatClient'

export { $nsid }

const main = l.permissionSet(
  $nsid,
  [
    l.permission('rpc', {
      inheritAud: true,
      lxm: [
        'chat.bsky.actor.deleteAccount',
        'chat.bsky.actor.exportAccountData',
        'chat.bsky.convo.acceptConvo',
        'chat.bsky.convo.addReaction',
        'chat.bsky.convo.deleteMessageForSelf',
        'chat.bsky.convo.getConvo',
        'chat.bsky.convo.getConvoAvailability',
        'chat.bsky.convo.getConvoForMembers',
        'chat.bsky.convo.getLog',
        'chat.bsky.convo.getMessages',
        'chat.bsky.convo.leaveConvo',
        'chat.bsky.convo.listConvos',
        'chat.bsky.convo.muteConvo',
        'chat.bsky.convo.removeReaction',
        'chat.bsky.convo.sendMessage',
        'chat.bsky.convo.sendMessageBatch',
        'chat.bsky.convo.unmuteConvo',
        'chat.bsky.convo.updateAllRead',
        'chat.bsky.convo.updateRead',
      ],
    }),
    l.permission('repo', {
      action: ['create', 'update', 'delete'],
      collection: ['chat.bsky.actor.declaration'],
    }),
  ],
  {
    title: 'Full Chat Client (All Conversations)',
    'title:lang': {},
    detail: 'Control of all chat conversations and configuration management.',
    'detail:lang': { en: 'All Chat Conversations' },
  },
)

export { main }
